import { AttachService } from '@/data/services/attach.service';
import { AuthService } from '@/data/services/auth.service';
import { CallCenterService } from '@/data/services/callcenter.service';
import { CampaignService } from '@/data/services/campaign.service';
import { ContoService } from '@/data/services/conto.service';
import { CrudService } from '@/data/services/crud.service';
import { ListService } from '@/data/services/list.service';
import { MovementService } from '@/data/services/movimento.service';
import { OfferService } from '@/data/services/offer.service';
import { PeriodicEntityService } from '@/data/services/periodic.service';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';
import { UserService } from '@/data/services/user.service';
import { ServiceContainer } from '@/data/utils/service-container';

const container = new ServiceContainer();
container.set('CrudService', CrudService);
container.set('AuthService', AuthService);
container.set('UserService', UserService);
container.set('CampaignService', CampaignService);
container.set('CallCenterService', CallCenterService);
container.set('OfferService', OfferService);
container.set('AttachService', AttachService);
container.set('ListService', ListService);
container.set('PeriodicEntityService', PeriodicEntityService);
container.set('ServiceInstanceService', ServiceInstanceService);
container.set('ContoService', ContoService);
container.set('MovementService', MovementService);

export default container;
